import {Editor} from "@tiptap/core";
import {Transaction} from "prosemirror-state";
import {DceJsx, DceJsxRenderer} from "dce-jsx";
import {ToolbarItem} from "./ToolbarItem";

export class EnabledButtonItem extends ToolbarItem {

    private editor: Editor;
    private isEnabledCallback: (editor: Editor) => boolean;
    private actionCallback: (editor: Editor) => void;
    private icon: string;

    constructor(isEnabledCallback: (editor: Editor) => boolean, actionCallback: (editor: Editor) => void, icon: string) {
        super();
        this.isEnabledCallback = isEnabledCallback;
        this.actionCallback = actionCallback;
        this.icon = icon;
    }

    public mount(editor: Editor): void {
        this.editor = editor;
    }
    
    public consumeTransaction(editor: Editor, transaction: Transaction): void{
        if(!this.isEnabledCallback(editor)){
            this.root.classList.add('disabled');
        }else{
            this.root.classList.remove('disabled');
        }
    }

    public click(){
        this.actionCallback(this.editor);
    }

    render(): JSX.Element {
        return (
            <button type="button" onClick={() => this.click()} dangerouslySetInnerHTML={ {__html: this.icon} }></button>
        )
    }

}